var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "select-container",
      class: { changed: _vm.changed },
      style: { height: _vm.height, width: _vm.width },
      attrs: { disabled: _vm.disabled }
    },
    [
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.selectedValue,
              expression: "selectedValue"
            }
          ],
          ref: "select",
          class: { "disabled-select": _vm.disabled },
          attrs: { "data-cs-mask": "", name: _vm.name, disabled: _vm.disabled },
          on: {
            click: _vm.flip,
            blur: _vm.unFlip,
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.selectedValue = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              function($event) {
                _vm.valueChanged($event.target.value)
              }
            ]
          }
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm._l(_vm.items, function(item) {
            return _c(
              "option",
              {
                key: item.value,
                attrs: { "data-cs-mask": "", "aria-label": item.ariaLabel },
                domProps: { value: item.value }
              },
              [_vm._v(_vm._s(item.text))]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          ref: "flipImg",
          staticClass: "select-arrow unflip180",
          style: { height: _vm.height, width: _vm.height }
        },
        [_c("i", { staticClass: "arrow" })]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35bb41d1", { render: render, staticRenderFns: staticRenderFns })
  }
}